export const clinicSlides = [
  {
    image: "/images/hero-main.jpg",
    alt: "Skin Sattva premium interior",
    tag: "Skin • Hair • Lasers",
    title: "Where Beauty Meets Science",
    subtitle: "Advanced dermatology care in Davanagere",
    description:
      "World-class skin, hair and laser treatments with a personalized, ethical, and scientific approach.",
  },
  {
    image: "/images/clinic-1.jpg",
    alt: "Skinsattva clinic reception with elegant marble wall",
    tag: "Premium Ambience",
    title: "Welcome to Skinsattva",
    subtitle: "Premium Skin, Hair & Laser Care",
    description:
      "A calming and modern clinic space designed for confident, result-focused treatments.",
  },
  {
    image: "/images/clinic-2.jpg",
    alt: "Clinic procedure room entrance with branded glass panels",
    tag: "Procedure Suite",
    title: "Advanced Procedure Rooms",
    subtitle: "Safe, Hygienic, Technology-Driven",
    description:
      "Every treatment room is prepared with strict safety, sterilization, and precision systems.",
  },
  {
    image: "/images/clinic-3.jpg",
    alt: "Doctor consultation room with seating and turquoise sofa",
    tag: "Consultation Zone",
    title: "Comfortable Consultations",
    subtitle: "Personalized Care Plans",
    description:
      "Discuss your skin and hair goals in a private, comfortable setting with expert guidance.",
  },
];

export const aboutContent = {
  title: "Davanagere’s premier destination for advanced skin and hair treatments.",
  paragraphs: [
    "Welcome to Skin Sattva, founded by Dr. Shrenik Balegar with a vision to bring world-class dermatological care to smaller cities like Davanagere—without the high metro-city price tag.",
    "Understanding the challenge of accessing premium skin care, Skin Sattva bridges the gap by offering advanced treatments usually available only in major cities, right here in hometown Davanagere.",
    "At Skin Sattva, we combine advanced technology, expert medical care, and personalized treatment plans to ensure the best outcomes for every patient.",
    "We diagnose and treat age-old skin diseases such as psoriasis and eczema while also offering latest aesthetic procedures including chemical peels, anti-aging injectables, laser hair reduction, laser toning, scar reduction, medifacials, hair loss treatments, and hair transplantation.",
    "All services are delivered in a state-of-the-art facility designed for comfort and care. We believe quality skincare should be accessible to everyone, which is why top-tier treatments are offered at affordable costs.",
    "At Skin Sattva, beauty meets science, and every patient is treated with the highest level of expertise and compassion. Your skin’s health and confidence always come first.",
  ],
  approachPoints: ["Advanced technology", "Expert medical care", "Personalized treatment plans"],
  featuredServices: [
    "Chemical peels",
    "Anti-aging injectables",
    "Laser hair reduction",
    "Laser toning",
    "Scar reduction",
    "Medifacials",
    "Hair loss treatments",
    "Hair transplantation",
  ],
};

export const whyUsPoints = [
  "Expert & Qualified Dermatologists",
  "Comfortable & luxurious ambiance",
  "Personalized & Affordable Treatments",
  "Authentic & Scientific approach - No false or fake claims",
  "Trusted by thousands!",
];

export const primaryServices = [
  "Hair transplantation",
  "Laser Hair Reduction",
  "Medifacials",
  "Acne control treatment",
  "Pigmentation Reduction",
  "Anti-aging treatments",
  "Phototherapy",
  "Dermatosurgery",
];

export const serviceCategories = [
  {
    slug: "skin",
    title: "Skin",
    description: "Clinical dermatology support for chronic and acute skin conditions.",
    items: [
      "Acne control therapy",
      "Psoriasis",
      "Eczema",
      "Vitiligo",
      "Keloids",
      "Lichen Planus",
      "Fungal Infection",
      "Urticaria control treatment",
    ],
  },
  {
    slug: "hair",
    title: "Hair",
    description: "Medically guided hair restoration with advanced transplantation options.",
    items: [
      "Hair loss treatments",
      "PRP",
      "GFC",
      "QR678",
      "EXOSOMES",
      "Low-level laser therapy",
      "Hair Transplantation: FUE, Sapphire FUE, Bio Sapphire FUE, DHI, AHI",
    ],
  },
  {
    slug: "aesthetics",
    title: "Aesthetics",
    description: "Evidence-based aesthetic procedures for brighter, healthier-looking skin.",
    items: [
      "Laser Hair Reduction",
      "Laser Toning",
      "Acne Scar Reduction",
      "Chemical peels",
      "Medifacial",
      "Botox & Fillers",
      "Threadlift",
      "RF facelift",
      "HIFU",
      "Microneedling",
    ],
  },
  {
    slug: "dermatosurgery",
    title: "Dermatosurgery",
    description: "Specialized minor surgical procedures performed by experienced dermatology experts.",
    items: ["Skin tag removal", "Mole removal", "Vitiligo Surgery", "Cyst excision", "Punch excision", "Punch biopsy"],
  },
];

export const doctorProfile = {
  name: "Dr. Shrenik Balegar",
  role: "Founder | Dermatologist | Hair Transplant Specialist",
  intro:
    "Dr. Shrenik Balegar is a distinguished dermatologist specializing in dermatology, aesthetics, and hair transplantation.",
  paragraphs: [
    "After post-graduation, he gained advanced experience at Skincity Pune, one of India’s largest dermatology and laser centers, and further refined hair transplantation expertise under Dr. Kapil Dua, a pioneer in hair restoration.",
    "He has led and contributed across Dermadent Skin, Hair & Dental Clinic (Mumbai), Skin Sattva (Davanagere), and MakeO-Skinnsi (Mumbai), including research, product innovation, SOP finalization, and technology advancement.",
    "His clinical philosophy—Every graft should grow—reflects meticulous planning, precision execution, and patient-first care for long-term outcomes.",
  ],
  education: [
    "MBBS — JJM Medical College, Davanagere (2012)",
    "MD Dermatology, Venereology and Leprosy — Ranchi University (2017)",
    "Gold Medal for academic excellence in MD Dermatology",
  ],
  expertise: [
    "Clinical Dermatology: STDs, acne, melasma, psoriasis and other skin disorders",
    "Phototherapy: Excimer and NBUVB for vitiligo and chronic skin diseases",
    "Vitiligo surgeries: ultrathin epidermal grafting, suction blister and mini punch grafting",
    "Scar revision and nail surgeries",
    "Hair transplantation: Bio-FUE, advanced implantation techniques, Aesthetic Hair Integration (AHI)",
    "Cosmetology: chemical peels, microdermabrasion, medifacials, mesotherapy, PRP, microneedling, MNRF",
    "Lasers and anti-aging: QS Nd:YAG, Diode/Alexandrite/LP Nd:YAG, fractional CO2, Erbium YAG, Botox, fillers, threads, RF, HIFU",
  ],
  leadership: [
    "Co-founder, Dermadent Skin, Hair & Dental Clinic (Mumbai)",
    "Founder, Skin Sattva — Dermatology, Aesthetics and Hair Restoration Center (Davanagere)",
    "Senior Dermatologist at MakeO-Skinnsi, Mumbai (R&D, SOP and technology leadership)",
  ],
  publications: [
    "Authored chapters in postgraduate dermatology textbooks",
    "Authored a handbook on hair transplantation",
    "Research focus on advancements in hair restoration instruments, punches and implantation techniques",
  ],
  achievements: [
    "Gold medalist in MD Dermatology",
    "First place in award paper presentation at CUTICON Jharkhand 2017",
    "Free paper presentation at DERMACON 2017",
    "Third place in Zonal Torrent Young Scholar Award (TYSA) Quiz",
    "Contestant in Kannadada Kotyadhipathi (2012), hosted by Dr. Puneeth Rajkumar",
    "Faculty at Laser 3D workshop, ACSICON 2018 (Daman)",
    "Faculty at DERMACON 2020; panelist and speaker on Laser Sweat Ablation in Hyperhidrosis",
  ],
  memberships: ["IADVL (LM/M/8769)", "ACSICON (Association of Cutaneous Surgeons of India)"],
  philosophy: "Every graft should grow.",
};
